import { buildBrandingVars } from 'lib/helpers/brandColors';
import { DEFAULT_BRAND_COLOR, getBrandColor } from 'lib/constants/brandPalette';

import {
  getEffectiveAccent,
  isDefaultBranding,
  isTwoColor,
  resolveBranding
} from './resolveBranding';

export const getBrandingSummary = (draft) => {
  if (isDefaultBranding(draft)) {
    return {
      title: getBrandColor(DEFAULT_BRAND_COLOR).label,
      description: 'The standard Myriad look. Choose your own colors to match your practice.'
    };
  }
  const main = getBrandColor(draft.main_color);
  if (!isTwoColor(draft)) {
    return {
      title: main.label,
      description: 'One brand color everywhere. Customize to change the color or shade.'
    };
  }
  const accent = getBrandColor(getEffectiveAccent(draft).key);
  return {
    title: `${main.label} & ${accent.label}`,
    description: `${main.label} for main components, ${accent.label} for other details.`
  };
};

// Scoped CSS variables for the live preview: Tailwind's `primary` scale resolves through
// `--color-primary-*`, so setting them on the preview wrapper themes every shared component
// inside it exactly like the patient-facing provider does. The default look sets nothing so
// the preview shows the stock Myriad ramp rather than a generated approximation of it.
export const buildPreviewVars = (draft) =>
  isDefaultBranding(draft) ? {} : buildBrandingVars(resolveBranding(draft));
